import React from "react";
import firebase from "firebase.config";

export default class Events extends React.Component {
  state = {
    headers: [
      {
        name: "",
        title: "",
        text: "",
        url: "",
        background: ""
      }
    ],
    events: []
  };

  // ----- Tailwind 공통 입력 스타일 -----
  inputCls =
    "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 shadow-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200";

  componentDidMount = () => {
    this.initialize();
  };

  initialize = () => {
    console.log("Props:", this.props);
    this.setState({
      events: this.props.events
    });
  };

  addEvent = () => {
    let { name, title, text, url, background } = this.state.headers[0];
    if (name.length < 2) {
      alert("Please enter valid title");
      return;
    }
    if (title.length < 4) {
      alert("Please enter valid URL");
      return;
    }
    if (title.length < 4) {
      alert("Please enter valid background Image URL");
      return;
    }
    firebase
      .database()
      .ref("/groupsData/" + this.props.userDetails.groupPath + "/events")
      .push({
        name,
        title,
        text,
        url,
        background
      })
      .then(res => {
        this.setState({
          name: "",
          title: "",
          text: "",
          url: "",
          background: ""
        });
      });
  };

  handleChange = (event, key) => {
    var temp = this.state.headers;

    if (key === "name") {
      temp[0].name = event.target.value;
    } else if (key === "title") {
      temp[0].title = event.target.value;
    } else if (key === "text") {
      temp[0].text = event.target.value;
    } else if (key === "url") {
      temp[0].url = event.target.value;
    }

    this.setState({
      headers: temp
    });
  };

  deleteEvent = event => {
    let res = window.confirm(
      '"' + event.name + '" 이벤트를 삭제하시겠습니까?'
    );
    if (res) {
      firebase
        .database()
        .ref(
          "/groupsData/" +
            this.props.userDetails.groupPath +
            "/events/" +
            event.key
        )
        .remove();
    }
  };

  addImage = async event => {
    var temp = this.state.headers;
    temp[0].imageTemp = event.target.files[0];

    this.setState({
      headers: temp
    });

    console.log("Image To Be Uploaded!");

    await this.saveImage();
  };

  saveImage = async () => {
    let temp = this.state.headers;
    let file = temp[0].imageTemp;

    if (file) {
      var min = 1;
      var max = 100;
      var rand = min + Math.random() * (max - min);

      var filename = "event" + "+" + rand;

      const storage = firebase.storage().ref();
      const image = storage.child(filename);

      await image.put(file).then(async snapshot => {
        await image.getDownloadURL().then(async url => {
          console.log("Image URL:", url);
          temp[0].background = url;
          delete temp[0].imageTemp;
          this.setState({
            headers: temp
          });
        });
      });
      console.log("Image Uploaded!!!");
    }
  };

  moveUp = index => {
    var temp = this.state.events;
    var temp2 = temp[index - 1];

    temp[index - 1] = temp[index];
    temp[index] = temp2;

    this.setState({
      events: temp
    });

    this.saveToDB();
  };

  moveDown = index => {
    var temp = this.state.events;
    var temp2 = temp[index + 1];

    temp[index + 1] = temp[index];
    temp[index] = temp2;

    this.setState({
      events: temp
    });

    this.saveToDB();
  };

  saveToDB = () => {
    console.log("/groupsData/" + this.props.userDetails.groupPath + "/events");
    firebase
      .database()
      .ref("/groupsData/" + this.props.userDetails.groupPath + "/events/")
      .remove();

    this.state.events.map((event, index) => {
      var temp = this.state.headers;
      temp[0].name = event.name;
      temp[0].title = event.title;
      temp[0].text = event.text;
      temp[0].url = event.url;
      temp[0].background = event.background;

      this.addEvent();
    });
  };

  render() {
    if (!this.props.userDetails.group) {
      return (
        <div className="content">
          <div className="mx-auto w-full max-w-3xl px-2 pb-10">
            <div className="rounded-2xl border border-amber-200 bg-amber-50 p-6 text-sm text-amber-700">
              <b>{this.props.userDetails.name}</b>님, 이벤트를 추가하려면 먼저
              대시보드에서 그룹 고유 ID를 설정해 주세요.
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="content">
        <div className="mx-auto w-full max-w-3xl px-2 pb-10">
          {/* 안내 배너 */}
          <div className="mb-6 rounded-2xl bg-gradient-to-r from-sky-500 to-cyan-400 p-6 text-white shadow-lg">
            <h2 className="mb-1 text-2xl font-bold">🎪 이벤트 관리</h2>
            <p className="text-sm leading-relaxed text-sky-50">
              앱에 노출할 이벤트를 추가하고 순서를 정리하세요. 아래에서 새 이벤트를
              등록하면 목록에 바로 표시됩니다.
            </p>
          </div>

          {/* 새 이벤트 등록 */}
          <section className="mb-6 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-sky-600">
                +
              </span>
              <h3 className="text-lg font-bold text-gray-800">새 이벤트 등록</h3>
            </div>

            <div className="space-y-4">
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                  <label className="mb-1 block text-xs font-semibold text-gray-600">
                    이벤트 이름
                  </label>
                  <input
                    type="text"
                    placeholder="예) 봄맞이 바자회"
                    value={this.state.name}
                    className={this.inputCls}
                    onChange={event => this.handleChange(event, "name")}
                  />
                </div>
                <div>
                  <label className="mb-1 block text-xs font-semibold text-gray-600">
                    제목
                  </label>
                  <input
                    type="text"
                    placeholder="예) 5월 가족 행사"
                    value={this.state.title}
                    className={this.inputCls}
                    onChange={event => this.handleChange(event, "title")}
                  />
                </div>
              </div>

              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  간단한 설명
                </label>
                <textarea
                  rows={3}
                  placeholder="예) 5월 3일 오후 2시, 1층 로비에서 진행됩니다."
                  value={this.state.info}
                  className={this.inputCls + " resize-y"}
                  onChange={event => this.handleChange(event, "text")}
                />
              </div>

              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  링크 (URL)
                </label>
                <input
                  type="text"
                  placeholder="예) https://example.com/event"
                  value={this.state.url}
                  className={this.inputCls}
                  onChange={event => this.handleChange(event, "url")}
                />
              </div>

              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  이미지
                </label>
                <div className="flex flex-col items-start gap-4 rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 p-4 sm:flex-row sm:items-center">
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    ref={ref => (this.myInput = ref)}
                    onChange={event => this.addImage(event)}
                  />
                  <button
                    type="button"
                    className="inline-flex items-center gap-2 rounded-lg bg-sky-500 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-sky-600"
                    onClick={() => this.myInput.click()}
                  >
                    🖼️ 이미지 선택
                  </button>
                  {this.state.headers[0].background ? (
                    <img
                      src={this.state.headers[0].background}
                      alt="이벤트 이미지 미리보기"
                      className="h-20 w-20 rounded-lg object-cover shadow"
                    />
                  ) : (
                    <span className="text-xs text-gray-400">
                      아직 이미지를 선택하지 않았어요.
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="mt-6 flex justify-end">
              <button
                type="button"
                className="inline-flex items-center gap-2 rounded-xl bg-sky-500 px-6 py-2.5 text-sm font-bold text-white shadow-md transition hover:bg-sky-600"
                onClick={() => {
                  this.addEvent();
                  console.log("Events Obj:", this.state.headers);
                }}
              >
                + 이벤트 추가
              </button>
            </div>
          </section>

          {/* 이벤트 목록 */}
          <section className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-sky-600">
                ☰
              </span>
              <h3 className="text-lg font-bold text-gray-800">등록된 이벤트</h3>
            </div>

            {this.state.events.length === 0 ? (
              <div className="rounded-xl bg-gray-50 p-8 text-center text-sm text-gray-400">
                아직 등록된 이벤트가 없습니다.
              </div>
            ) : (
              <div className="space-y-3">
                {this.state.events.map((event, index) => (
                  <div
                    key={index}
                    className="flex flex-col gap-4 rounded-xl border border-gray-200 bg-gray-50/60 p-4 sm:flex-row sm:items-center"
                  >
                    {event.background && (
                      <img
                        src={event.background}
                        alt=""
                        className="h-20 w-20 shrink-0 cursor-pointer rounded-lg object-cover shadow"
                        onClick={() => window.open(event.background, "_blank")}
                      />
                    )}
                    <div className="min-w-0 flex-1">
                      <div className="font-bold text-gray-800">{event.name}</div>
                      <div className="text-sm text-gray-600">{event.title}</div>
                      {event.info && (
                        <div className="mt-1 text-xs text-gray-500">
                          {event.info}
                        </div>
                      )}
                      {event.url && (
                        <a
                          href={event.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="mt-1 inline-block break-all text-xs text-sky-500 hover:underline"
                        >
                          {event.url}
                        </a>
                      )}
                    </div>
                    <div className="flex shrink-0 items-center gap-2">
                      <button
                        type="button"
                        title="위로"
                        disabled={index === 0}
                        className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
                        onClick={() => this.moveUp(index)}
                      >
                        ↑
                      </button>
                      <button
                        type="button"
                        title="아래로"
                        disabled={index === this.state.events.length - 1}
                        className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
                        onClick={() => this.moveDown(index)}
                      >
                        ↓
                      </button>
                      <button
                        type="button"
                        className="inline-flex items-center gap-1 rounded-lg border border-rose-200 bg-white px-3 py-2 text-xs font-medium text-rose-500 transition hover:bg-rose-50"
                        onClick={() => this.deleteEvent(event)}
                      >
                        🗑️ 삭제
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </section>
        </div>
      </div>
    );
  }
}
